import { META } from "../../utils/constants";
import LeadFormSummaryCard from "../LeadForm/LeadFormSummaryCard";

const MetaInstantFormSummaryCard = (props) => (
  <LeadFormSummaryCard platform={META} {...props} />
);

export default MetaInstantFormSummaryCard;
